// Define action types
export const GET_DOCUMENT_BY_ID = "GET_DOCUMENT_BY_ID";
export const GET_DOCUMENT_BY_ID_SUCCESS = "GET_DOCUMENT_BY_ID_SUCCESS";
export const GET_DOCUMENT_BY_ID_FAIL = "GET_DOCUMENT_BY_ID_FAIL";

export const GET_HISTORY_BY_ID = "GET_HISTORY_BY_ID";
export const GET_HISTORY_BY_ID_SUCCESS = "GET_HISTORY_BY_ID_SUCCESS";
export const GET_HISTORY_BY_ID_FAIL = "GET_HISTORY_BY_ID_FAIL";

export const GET_EXPORT_DATA = "GET_EXPORT_DATA";
export const GET_EXPORT_DATA_SUCCESS = "GET_EXPORT_DATA_SUCCESS";
export const GET_EXPORT_DATA_FAIL = "GET_EXPORT_DATA_FAIL";
export const GET_EXPORT_DATA_API_CALL = "GET_EXPORT_DATA_API_CALL";

export const GET_EXPORT_DATA_FOR_VIEW = "GET_EXPORT_DATA_FOR_VIEW";
export const GET_EXPORT_DATA_FOR_VIEW_SUCCESS =
  "GET_EXPORT_DATA_FOR_VIEW_SUCCESS";
export const GET_EXPORT_DATA_FOR_VIEW_FAIL = "GET_EXPORT_DATA_FOR_VIEW_FAIL";
export const GET_EXPORT_DATA_FOR_VIEW_API_CALL =
  "GET_EXPORT_DATA_FOR_VIEW_API_CALL";
